// extracted by mini-css-extract-plugin
export default {"formStepper":"Style_formStepper__Gl2uJ","steps":"Style_steps__14VSu","body":"Style_body__KJk9T","footer":"Style_footer__ARy4-","actions":"Style_actions__xV46I"};